export enum HistoryStackLastAction {
  Backward = 'backward',
  Forward = 'forward',
  Pop = 'pop',
  Push = 'push',
  Replace = 'replace',
}
